

export const actionTypes = {
    FETCH_API_REFERENCES: "FETCH_API_REFERENCES",
    FETCH_API_REFERENCES_SUCCESS: "FETCH_API_REFERENCES_SUCCESS",
    FETCH_API_REFERENCES_UNSUCCESS: "FETCH_API_REFERENCES_UNSUCCESS",
    FETCH_API_REFERENCES_FAIL: "FETCH_API_REFERENCES_FAIL",
    FETCH_COMPANIES: "FETCH_COMPANIES",
    FETCH_COMPANIES_SUCCESS: "FETCH_COMPANIES_SUCCESS",
    FETCH_COMPANIES_UNSUCCESS: "FETCH_COMPANIES_UNSUCCESS",
    FETCH_COMPANIES_FAIL: "FETCH_COMPANIES_FAIL",
    FETCH_COMPANY: "FETCH_COMPANY",
    FETCH_COMPANY_SUCCESS: "FETCH_COMPANY_SUCCESS",
    FETCH_COMPANY_UNSUCCESS: "FETCH_COMPANY_UNSUCCESS",
    FETCH_COMPANY_FAIL: "FETCH_COMPANY_FAIL",
    FETCH_CAMPAIGNS: "FETCH_CAMPAIGNS",
    FETCH_CAMPAIGNS_SUCCESS: "FETCH_CAMPAIGNS_SUCCESS",
    FETCH_CAMPAIGNS_UNSUCCESS: "FETCH_CAMPAIGNS_UNSUCCESS",
    FETCH_CAMPAIGNS_FAIL: "FETCH_CAMPAIGNS_FAIL",
    FETCH_ADVERTISEMENTS: "FETCH_ADVERTISEMENTS",
    FETCH_ADVERTISEMENTS_SUCCESS: "FETCH_ADVERTISEMENTS_SUCCESS",
    FETCH_ADVERTISEMENTS_UNSUCCESS: "FETCH_ADVERTISEMENTS_UNSUCCESS",
    FETCH_ADVERTISEMENTS_FAIL: "FETCH_ADVERTISEMENTS_FAIL",
    FETCH_ADVERTISEMENT: "FETCH_ADVERTISEMENT",
    FETCH_ADVERTISEMENT_SUCCESS: "FETCH_ADVERTISEMENT_SUCCESS",
    FETCH_ADVERTISEMENT_UNSUCCESS: "FETCH_ADVERTISEMENT_UNSUCCESS",
    FETCH_ADVERTISEMENT_FAIL: "FETCH_ADVERTISEMENT_FAIL",
    FETCH_ADVERTISEMENT_BY_CODE: "FETCH_ADVERTISEMENT_BY_CODE",
    FETCH_ADVERTISEMENT_BY_CODE_SUCCESS: "FETCH_ADVERTISEMENT_BY_CODE_SUCCESS",
    FETCH_ADVERTISEMENT_BY_CODE_UNSUCCESS: "FETCH_ADVERTISEMENT_BY_CODE_UNSUCCESS",
    FETCH_ADVERTISEMENT_BY_CODE_FAIL: "FETCH_ADVERTISEMENT_BY_CODE_FAIL",
    CLEAN_ADVERTISEMENT_BY_CODE: "CLEAN_ADVERTISEMENT_BY_CODE",
    UPDATE_ADVERTISEMENT: "UPDATE_ADVERTISEMENT",
    UPDATE_ADVERTISEMENT_SUCCESS: "UPDATE_ADVERTISEMENT_SUCCESS",
    UPDATE_ADVERTISEMENT_UNSUCCESS: "UPDATE_ADVERTISEMENT_UNSUCCESS",
    UPDATE_ADVERTISEMENT_FAIL: "UPDATE_ADVERTISEMENT_FAIL",
    FETCH_POSTS: "FETCH_POSTS",
    FETCH_POSTS_SUCCESS: "FETCH_POSTS_SUCCESS",
    FETCH_POSTS_UNSUCCESS: "FETCH_POSTS_UNSUCCESS",
    FETCH_POSTS_FAIL: "FETCH_POSTS_FAIL",
    FETCH_POSTS_SUCCESS_BUFFER_FLUSH: "FETCH_POSTS_SUCCESS_BUFFER_FLUSH",
    FETCH_POSTS_SUCCESS_BUFFER_FLUSH_SUCCESS: "FETCH_POSTS_SUCCESS_BUFFER_FLUSH_SUCCESS",
    FETCH_PERSON_CREDENTIALS: "FETCH_PERSON_CREDENTIALS",
    FETCH_PERSON_CREDENTIALS_SUCCESS: "FETCH_PERSON_CREDENTIALS_SUCCESS",
    FETCH_PERSON_CREDENTIALS_UNSUCCESS: "FETCH_PERSON_CREDENTIALS_UNSUCCESS",
    FETCH_PERSON_CREDENTIALS_FAIL: "FETCH_PERSON_CREDENTIALS_FAIL",
    FETCH_PERSON_CREDENTIALS_SUCCESS_BUFFER_FLUSH: "FETCH_PERSON_CREDENTIALS_SUCCESS_BUFFER_FLUSH",
    FETCH_PERSON_CREDENTIALS_SUCCESS_BUFFER_FLUSH_SUCCESS: "FETCH_PERSON_CREDENTIALS_SUCCESS_BUFFER_FLUSH_SUCCESS",
    SET_LANGUAGE: "SET_LANGUAGE",
    SELECT_CAMPAIGN: "SELECT_CAMPAIGN",
    AUTHENTICATE_GUEST: "AUTHENTICATE_GUEST",
    AUTHENTICATE_GUEST_SUCCESS: "AUTHENTICATE_GUEST_SUCCESS",
    AUTHENTICATE_GUEST_UNSUCCESS: "AUTHENTICATE_GUEST_UNSUCCESS",
    AUTHENTICATE_FAIL: "AUTHENTICATE_FAIL",
    AUTHENTICATE: "AUTHENTICATE",
    AUTHENTICATE_SUCCESS: "AUTHENTICATE_SUCCESS",
    AUTHENTICATE_UNSUCCESS: "AUTHENTICATE_UNSUCCESS",
    LOGIN: "LOGIN",
    LOGIN_FAIL: "LOGIN_FAIL",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_UNSUCCESS: "LOGIN_UNSUCCESS",
    LOGOUT: "LOGOUT",
    SIGNUP: "SIGNUP",
    SIGNUP_FAIL: "SIGNUP_FAIL",
    SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
    SIGNUP_UNSUCCESS: "SIGNUP_UNSUCCESS",
    SIGNUP_CLEAR_STATUS: "SIGNUP_CLEAR_STATUS",
    CREATE_COMPANY: "CREATE_COMPANY",
    CREATE_COMPANY_FAIL: "CREATE_COMPANY_FAIL",
    CREATE_COMPANY_SUCCESS: "CREATE_COMPANY_SUCCESS",
    CREATE_COMPANY_UNSUCCESS: "CREATE_COMPANY_UNSUCCESS",
    UPDATE_USER: "UPDATE_USER",
    UPDATE_USER_FAIL: "UPDATE_USER_FAIL",
    UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
    UPDATE_USER_UNSUCCESS: "UPDATE_USER_UNSUCCESS",
    UPDATE_COMPANY: "UPDATE_COMPANY",
    UPDATE_COMPANY_FAIL: "UPDATE_COMPANY_FAIL",
    UPDATE_COMPANY_SUCCESS: "UPDATE_COMPANY_SUCCESS",
    UPDATE_COMPANY_UNSUCCESS: "UPDATE_COMPANY_UNSUCCESS",
    APPLY_GUEST_TOKEN: "APPLY_GUEST_TOKEN",
    DELETE_MY_DATA: "DELETE_MY_DATA",
    FETCH_TERMS_AND_CONDITIONS: "FETCH_TERMS_AND_CONDITIONS",
    FETCH_TERMS_AND_CONDITIONS_SUCCESS: "FETCH_TERMS_AND_CONDITIONS_SUCCESS",
    FETCH_TERMS_AND_CONDITIONS_UNSUCCESS: "FETCH_TERMS_AND_CONDITIONS_UNSUCCESS",
    FETCH_TERMS_AND_CONDITIONS_FAIL: "FETCH_TERMS_AND_CONDITIONS_FAIL",
    SET_CLUSTER_CONFIG: "SET_CLUSTER_CONFIG",
    FETCH_CLUSTER_CONFIG: "FETCH_CLUSTER_CONFIG",
    CLUSTER_UPDATE_DETECTED: "CLUSTER_UPDATE_DETECTED",
    TRACK_APP_DOWNLOAD: "TRACK_APP_DOWNLOAD",
};